import SecondaryWalletTypeGeneralSettings from "@/models/Products/ProductSettings/SecondaryWallets/General/SecondaryWalletTypeGeneralSettings";
import SecondaryWalletTypeDepositInterestSettings from "@/models/Products/ProductSettings/SecondaryWallets/Savings/SecondaryWalletTypeDepositInterestSettings";

export default class SecondaryWalletType {
    id: string = '';
    overridable: boolean = false;
    enabled: boolean = false;
    generalSettings: SecondaryWalletTypeGeneralSettings = new SecondaryWalletTypeGeneralSettings();
    depositInterestSettings: SecondaryWalletTypeDepositInterestSettings = new SecondaryWalletTypeDepositInterestSettings();
}